import * as React from "react";
import { getEquivalencyText } from "../hybrid-sizing/utils";

import styles from "../../styles/purchase-attribute-carousel-counter.module.scss";

export const getPurchaseAttributeRange = (sortedArr) => {
  let range = "";
  if (sortedArr && sortedArr.length > 2) {
    const { 0: first, length, [length - 1]: last } = sortedArr;
    range = `${first}-${last}`;
  }
  return range;
};

/**
 * Displays the primary label and range of sizes for the size selector.
 *
 * @param {Object} props - the component props
 * @param {string} props.headingRangeTitle - the title for the range of sizes
 * @param {string} props.id - the HTML id for the wrapping div
 * @param {boolean} props.isHeadingCountVisible - whether the range title is visible
 * @param {{ label: string, value: string }} props.primaryLabel - the primary label for the size selector
 * @param {string[]} props.rangeArray - the array of sizes
 * @param {boolean} props.hasInseams - whether the product has inseams or not
 * @param {React.ReactNode} props.children - any children to render
 * @param {boolean} props.isHybridSizingEnabled - whether hybrid sizing is enabled
 * @param {string} props.category - the category of the product
 * @param {React.ReactElement} props.icon - the icon to show next to the range title
 *
 * @returns {React.ReactElement}
 */
const PurchaseAttributeCarouselCounter = ({
  headingRangeTitle = "",
  id = "button-tile-group-label",
  isHeadingCountVisible = false,
  primaryLabel = { label: "", value: "" },
  rangeArray = [],
  hasInseams = false,
  children = null,
  isHybridSizingEnabled = false,
  category = "",
  icon = null
}) => (
  <div className={styles.purchaseAttributeCarouselCounter} id={id}>
    <p
      data-testid="primary-label"
      className={`lll-text-body-2 ${styles.labelContainer}`}
    >
      <span className={`lll-font-weight-semibold ${styles.label}`}>
        {primaryLabel.label}
      </span>
      {primaryLabel.value && <span>{primaryLabel.value}</span>}
      {primaryLabel.value &&
        isHybridSizingEnabled &&
        getEquivalencyText(category, primaryLabel.value) && (
          <span> {getEquivalencyText(category, primaryLabel.value)}</span>
        )}
    </p>
    {hasInseams && isHeadingCountVisible && (
      <div className="lll-text-body-3">
        <span data-testid="measurements-range">
          {headingRangeTitle} {getPurchaseAttributeRange(rangeArray)}
        </span>
        {/* A fully rendered icon needs to be passed in as a prop because the pdp-catalyst workspace does not yet have a loader for svg */}
        {icon}
      </div>
    )}
    {children}
  </div>
);

export default PurchaseAttributeCarouselCounter;
